import axios from 'axios'
import { useAsync } from 'react-async-hook'

import useTokens from './useTokens'

const fetchCurrentUser = async (token) =>
  await axios.get(`${process.env.base_api}/auth/current-user`, {
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`
    }
  })

export default function useCurrentUser() {
  const { token: userToken, adminToken } = useTokens()
  const token = userToken || adminToken
  const data = useAsync(fetchCurrentUser, [token])
  return data.result ? data.result.data.data : false
}
